import React from 'react';
import { isEmpty } from 'lodash';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import {
    ArrayOfObjectsV2,
    getFieldChangeItems,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from 'views/pages/admin/audit-log/service';

type SubjectFieldItem = {
    Name?: string;
    Label?: string;
    IsActive?: boolean;
    id?: {
        $oid: string;
    };
    DisplayIndex?: number;
    RecordId?: number;
};

type OverviewGridConfig = {
    SubjectFields: Partial<Array<unknown>>;
    CfId: {
        $oid: string;
    };
    A: {
        $oid: string;
    };
    D: boolean;
    H: number;
    T: {
        $date: string;
    };
    AuditDescription?: string;
    AuditDescriptionMessage?: string;
};

type OverviewGridChangeGridProps = {
    oldRecord: Partial<OverviewGridConfig>;
    newRecord: Partial<OverviewGridConfig>;
    oldItem?: Record<string, unknown>;
    newItem?: Record<string, unknown>;
};

const SMOverviewGridConfigRecordChangeGrid = ({
    oldRecord,
    newRecord,
    oldItem,
    newItem,
}: OverviewGridChangeGridProps) => {
    if (isEmpty(oldRecord) && isEmpty(newRecord)) return null;

    // Lots of ID fields to hide
    const hiddenFields: string[] = ['CfId', 'AuditDescription', 'AuditDescriptionMessage'];

    const arrayOfObjectsV2 = {
        SubjectFields: {
            valueResolver: (recordData: unknown) => {
                if (!recordData) {
                    return null;
                }
                const data = recordData as SubjectFieldItem;

                return `${(data.DisplayIndex ?? 0) + 1}. ${data.Name} Label: ${data.Label}`;
            },
            compareField: 'DisplayIndex',
            valueComparer: (oldObject, newObject) => {
                // Try to get value out of object, if defined
                const oldName = oldObject instanceof Object && 'Name' in oldObject ? oldObject.Name : null;
                const newName = newObject instanceof Object && 'Name' in newObject ? newObject.Name : null;

                const oldLabel = oldObject instanceof Object && 'Label' in oldObject ? oldObject.Label : null;
                const newLabel = newObject instanceof Object && 'Label' in newObject ? newObject.Label : null;

                // True means display. False means don't...
                return oldName !== newName || oldLabel !== newLabel;
            },
        },
    } satisfies ArrayOfObjectsV2;

    const refactoredOldRecord = {
        ...oldRecord,
        ...removePropertiesFromObject(oldRecord, hiddenFields),
    } as Record<string, unknown>;

    const refactoredNewRecord = {
        ...newRecord,
        ...removePropertiesFromObject(newRecord, hiddenFields),
    } as Record<string, unknown>;

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
            arrayOfObjectsV2,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { SMOverviewGridConfigRecordChangeGrid };
